import { FC, ReactNode, CSSProperties } from 'react'
import Image from 'next/legacy/image'
import classNames from 'classnames'
import Button, { TProps as TButtonProps } from 'components/Button'
import { TIconProps } from 'icons/types'
import styles from './Banner.module.scss'

type TBannerButtonProps = {
  label: string
  props: TButtonProps
}

export type TProps = {
  children?: ReactNode
  button?: TBannerButtonProps
  Icon?: {
    Component: FC<TIconProps>
    full?: boolean
  } & TIconProps
  image?: {
    src: string
    alt: string
    width: number
    height: number
  }
  large?: boolean
  noPadding?: boolean
  smallContainerPadding?: boolean
  onlyMobileLayout?: boolean
  pinkBg?: boolean
  greyBg?: boolean
  pinkContainer?: boolean
  greyContainer?: boolean
  darkContainer?: boolean
  greenContainer?: boolean
  noContainer?: boolean
}
const Banner: FC<TProps> = ({
  children,
  button,
  Icon,
  image,
  large,
  noPadding,
  smallContainerPadding,
  onlyMobileLayout,
  pinkBg,
  greyBg,
  pinkContainer,
  greyContainer,
  darkContainer,
  greenContainer,
  noContainer,
}) => {
  const bannerClasses = classNames(styles.ecBanner, {
    [styles.ecBannerNoPadding]: noPadding,
    [styles.ecBannerDefaultLayout]: !onlyMobileLayout,
    [styles.ecBannerPink]: pinkBg,
    [styles.ecBannerGrey]: greyBg,
  })
  const containerClasses = classNames(styles.ecBannerContainer, {
    [styles.ecBannerContainerPink]: pinkContainer,
    [styles.ecBannerContainerGrey]: greyContainer,
    [styles.ecBannerContainerDark]: darkContainer,
    [styles.ecBannerContainerGreen]: greenContainer,
    [styles.ecBannerNoContainer]: noContainer,
    [styles.ecBannerContainerSmallPadding]: smallContainerPadding,
    [styles.ecBannerContainerLarge]: large,
  })
  const iconWrapperClasses = classNames(styles.ecBannerIconWrapper, {
    [styles.ecBannerIconWrapperGrey]:
      (noContainer && greyBg) || (!noContainer && greyContainer),
    [styles.ecBannerIconWrapperFull]: Icon?.full,
  })
  const childrenContainerClasses = classNames(
    styles.ecBannerChildrenContainer,
    {
      [styles.ecBannerChildrenContainerDark]: darkContainer || greenContainer,
      [styles.ecBannerChildrenContainerNoMarginBottom]: !button,
    },
  )

  return (
    <div className={bannerClasses}>
      <div className={containerClasses}>
        {Icon?.Component && (
          <div className={iconWrapperClasses}>
            <Icon.Component
              color={Icon.color || 'grey90'}
              width={24}
              height={24}
              title={Icon.title}
            />
          </div>
        )}
        {image && (
          <div
            className={styles.ecBannerImage}
            style={
              {
                '--maxwidth': `${image.width}px` || '280px',
              } as CSSProperties
            }
          >
            <Image
              src={image.src}
              width={image.width}
              height={image.height}
              alt={image.alt}
            />
          </div>
        )}
        {children && <div className={childrenContainerClasses}>{children}</div>}
        {button && (
          <Button className={styles.ecBannerButton} {...button.props}>
            {button.label}
          </Button>
        )}
      </div>
    </div>
  )
}

export default Banner
